// Trove-internal email domains. The Bitbucket pipeline run link is only meaningful for internal
// users (external partner users have no Bitbucket access), so it is gated on these domains.
// Both are intentional: `@trove.co` is the standard staff domain; `@trove.com` was requested by
// product. Do NOT remove `@trove.com` as an apparent typo — it appears nowhere else in the repo by
// design. (Safe regardless of who owns the domain: the email comes from an authenticated,
// Trove-provisioned identity, so it can't be self-registered to gain internal status.)
const INTERNAL_EMAIL_DOMAINS = ['@trove.co', '@trove.com'];

/**
 * True when the email belongs to a Trove-internal user (the trove.co / trove.com domains).
 * Case-insensitive;
 * a missing/empty email is treated as external (false) — fail closed, so the internal-only link is
 * hidden unless the user is provably internal.
 */
export const isTroveInternalEmail = (email: string | undefined): boolean => {
  if (!email) {
    return false;
  }
  const normalized = email.trim().toLowerCase();
  return INTERNAL_EMAIL_DOMAINS.some(domain => normalized.endsWith(domain));
};
